import { Route, Switch } from "react-router";
import DocumentRenewalsTable from "./DocumentRenewalsTable";

export default () => (
  <Switch>
    <Route
      exact path="/reminders/documentrenewals"
      component={DocumentRenewalsTable}
    />
    
  </Switch>
);